import {
  Column,
  ColumnApi,
  CsvExportParams,
  GridApi,
  ProcessCellForExportParams,
  RowNode,
  ValueFormatterParams,
} from "ag-grid-community/main";
/***********************/
/* Angular + external */
import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { moment } from "shared/cubiq-model-multi-asset";
/***********************/
/* BFX */
// models
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterActionEvent } from "../../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
// services
import { BfxConfigService } from "../../../shared/auth-services/system-config/bfx-config.service";
import { TranslateService } from "@ngx-translate/core";
import {
  SystemConfigPromiseService,
  CurrencyPairCalendarLookupService,
  COLUMN_ORDER_EXECUTED_AMOUNT,
  COLUMN_ORDER_EXECUTED_AMOUNT_USD,
  COLUMN_REMAINING_AMOUNT_USD,
  COLUMN_REMAINING_AMOUNT,
  COLUMN_ORDER_AMOUNT,
  COLUMN_ORDER_SUSPENSION_FROM_DATE,
  COLUMN_ORDER_SUSPENSION_TO_DATE,
  PricingService,
  CcyLookupService,
} from "shared/cubiq-services";
import { UserLookupService } from "./../../../shared/cubiq-services/lookup/model/impl/UserLookupService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ValueDateHelper } from "shared/cubiq-services/model/orders/ValueDateHelper";
import {
  FIXING_DATE_UTC_FORMAT,
  COLUMN_ORDER_USD_AMOUNT_DATA,
} from "shared/cubiq-services/model/BmarkHedgeOrdersTableDefinitionFactory.constants";
import { COLUMN_TRADE_FIXING_SOURCE_CODE } from "shared/cubiq-services/model/TradeTableDefinitionFactory.constants";
import {
  COLUMN_DEALTPERC_AWAY,
  COLUMN_MARKET_ALLIN,
  COLUMN_MARKET_PTS,
  COLUMN_ORDER_EXPIRY_DATE,
  COLUMN_ORDER_FROM_DATE_HEADER,
} from "shared/cubiq-services/model/OrdersTableDefinitionFactory.constants";
import { UserNameHelper } from "shared/cubiq-services/model/orders/UserNameHelper";

// OMS-30890 Per Keith D, "-" is reserved for empty numerical fields.
import {
  EMPTY_AMT_RATE_VALUE,
  EMPTY_TEXT_VALUE,
} from "shared/cubiq-services/model/BaseTableDefinitionFactory";
import { BfxConfigIDRefHelper } from "../../../shared/helper-services/bfx-config-id-ref-helper";
import { BfxTradeBlotterComponent } from "app/bfx-blotter-trade/bfx-trade-blotter.component";
import { BmarkRiskData } from "shared/cubiq-services/model/benchmarks/BmarkRiskData.model";
import { BfxRiskTradeBlotterComponent } from "app/bfx-blotter-risk-trade/bfx-risk-trade-blotter.component";
import { BfxAlgoRiskTradeBlotterComponent } from "app/bfx-algo-monitor/bfx-algo-risk-trade-blotter.component";
import { CSVExportHelper } from "shared/helper-services/CSVExportHelper";

const FIELD_STRATEGY_ID = "strategyId";

@Injectable()
export class BfxDialogsProcessorService {
  /***************************************/
  /* DATA */
  public config: any = {
    debug: false,
  };

  private myValueDateHelper: ValueDateHelper;
  private userNameHelper: UserNameHelper;
  protected localeString: string = "DD-MMM-YY HH:mm:ss";

  private configurationSubscription: Subscription;
  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(
    private _configService: BfxConfigService,
    private _translationService: TranslateService,
    protected _currencyPairCalendarLookupService: CurrencyPairCalendarLookupService,
    protected _userLookup: UserLookupService,
    protected _sysConfigService: SystemConfigPromiseService,
    protected _ccyService: CcyLookupService,
  ) {
    this.subscribeToConfiguration();
    this.myValueDateHelper = new ValueDateHelper(this._currencyPairCalendarLookupService);
    this.userNameHelper = new UserNameHelper(this._userLookup, this._sysConfigService);
  }

  /**********************************************************************/
  /* INITIALIZATION */
  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config = config.general;
    });
  }
  /**********************************************************************/
  /* EXPORT TO CSV */
  public exportToCSV(
    _event: BfxBlotterActionEvent,
    _exportToFile: boolean,
    _filename: string | null,
  ): Promise<string | null> {
    let allColumns: Array<any> = [];
    let allColumnKeys: Array<any> = [];
    let filename = moment(new Date()).format("YYYY-MM-DD_HH-mm-ss") + "_" + _filename + ".csv";
    if (
      _event.ladderBlotter.gridOptions.columnApi &&
      _event.ladderBlotter.gridOptions.columnApi.getAllGridColumns().length > 0
    ) {
      allColumns = _event.ladderBlotter.gridOptions.columnApi.getAllGridColumns();

      let tradeBlotter: boolean =
        _event.ladderBlotter instanceof BfxTradeBlotterComponent ||
        _event.ladderBlotter instanceof BfxRiskTradeBlotterComponent ||
        _event.ladderBlotter instanceof BfxAlgoRiskTradeBlotterComponent;

      for (let i = 0; i < allColumns.length; i++) {
        //if ((allColumns[i].colId !== "selection" && (allColumns[i].visible || this.forceToCsv.includes(allColumns[i].colId))))
        if (
          allColumns[i].visible &&
          (!tradeBlotter || allColumns[i].colId != "selection") &&
          allColumns[i].colDef?.skipExport !== true
        ) {
          allColumnKeys.push(allColumns[i].colId);
        }
      }
    }
    if (_event.ladderBlotter.gridOptions.api) {
      // is the "id" not the Row id column?
      const selectedStrategyIdSet = new Set();

      const isTradeBlotter =
        _event.ladderBlotter instanceof BfxTradeBlotterComponent ||
        _event.ladderBlotter instanceof BfxRiskTradeBlotterComponent ||
        _event.ladderBlotter instanceof BfxAlgoRiskTradeBlotterComponent;

      const selectedIdSet = new Set();
      _event.selectedItems.forEach((item) => {
        let key: string = item[_event.ladderBlotter.tableDefinition.primaryKey].toString();
        let stratId = item[FIELD_STRATEGY_ID];
        selectedIdSet.add(key);
        if (null != stratId) {
          selectedStrategyIdSet.add(stratId.toString());
        }
      });

      let params: CsvExportParams = {
        skipHeader: false,
        columnGroups: false,
        skipFooters: true,
        skipGroups: true,
        skipPinnedTop: true,
        skipPinnedBottom: true,
        columnKeys: allColumnKeys,
        exportedRows: "all",
        onlySelected: false,
        suppressQuotes: false,
        fileName: filename, // "BfxBlotter.csv",
        processHeaderCallback: function (param: ValueFormatterParams) {
          let ret: string = param.column.getColId();
          switch (param.column.getColId()) {
            case "selection":
              ret = COLUMN_ORDER_FROM_DATE_HEADER;
              break;
            default:
              ret = param.column.getColDef().headerName;
              break;
          }
          return ret;
        },
        shouldRowBeSkipped: function (param: ValueFormatterParams) {
          let rowId: string = param.node.id;
          let stratId = param.node.data[FIELD_STRATEGY_ID];
          let relatedToSelected: boolean =
            selectedIdSet.has(rowId) ||
            (!isTradeBlotter && null != stratId && selectedStrategyIdSet.has(stratId.toString()));
          return !relatedToSelected;
        },
        processCellCallback: (param: ProcessCellForExportParams) => {
          const data = param.node.data;
          let correctParam = {
            ...param,
            data,
            colDef: param.column.getColDef(),
          } as ValueFormatterParams;
          let columnId = param.column.getColId();
          let ret = null;

          switch (columnId) {
            // TODO: refactor columnId cases
            case "isBuy":
              ret = param.value != null ? (param.value ? "Buy" : "Sell") : "";
              break;

            case "entryUserId":
            case "confirmedSalesUserId":
              ret = this.userNameHelper.retrieveData(correctParam.data, columnId);
              break;

            case "valueDate":
            case "tradeDate":
              // Ensure that Value Dates and Trade dates are exported as UTC
              if (param && param.value && typeof param.value.utc == "function") {
                param.value.utc();
              }
              ret = this.formatDate(param, "DD-MMM-YY");
              break;

            case "creationDate":
              ret = this.formatDate(param, this.localeString);
              break;

            case "settleDate":
              ret = CSVExportHelper.formatExportValue(
                correctParam,
                this.myValueDateHelper.formatValueDate(data?.settleDate, data?.settleTenor),
              );
              break;

            case "fixingTimeUTC":
              ret =
                param.value != null
                  ? CubiqTS.moment.utc(param.value).format(FIXING_DATE_UTC_FORMAT)
                  : EMPTY_TEXT_VALUE;
              break;

            case "entryDts":
            case "timestamp":
            case "fillDts":
            case "entryDate":
            case "fixingDate":
            case COLUMN_ORDER_SUSPENSION_FROM_DATE:
            case COLUMN_ORDER_SUSPENSION_TO_DATE:
              // Fixing dates for NDS are strings
              if (
                param.value &&
                param.value != EMPTY_TEXT_VALUE &&
                param.value != EMPTY_AMT_RATE_VALUE &&
                param.value.local
              ) {
                ret = param.value.local().format(this.localeString);
              } else {
                ret = param.value == null ? EMPTY_TEXT_VALUE : param.value;
              }
              break;

            case "stpHold":
            case "isAutoEligible":
            case "stpAggregationEnabled":
            case "isExternal":
              ret =
                param.value != null
                  ? param.value === true || param.value === 1
                    ? "Yes"
                    : "No"
                  : EMPTY_TEXT_VALUE;
              break;

            case COLUMN_ORDER_AMOUNT:
            case "fillAmount":
            case COLUMN_ORDER_USD_AMOUNT_DATA:
            case COLUMN_ORDER_EXECUTED_AMOUNT_USD:
            case COLUMN_REMAINING_AMOUNT_USD:
            case COLUMN_ORDER_EXECUTED_AMOUNT:
            case COLUMN_REMAINING_AMOUNT:
            case "npvOrderQty":
            case "amt1":
            case "amt2":
            case "usdEquivAmt":
              {
                ret = CSVExportHelper.formatExportValue(
                  correctParam,
                  param.value ? param.value.toFormat(0) : EMPTY_AMT_RATE_VALUE,
                );
                // Now check for a tooltip that will have more detail for swaps
                const order: CubiqTS.OrderDataImpl = correctParam.data;
                if (CubiqTS.RequestOrderType.BMARK === order.requestedOrderType) {
                  let riskData: BmarkRiskData = (order as any).risk;
                  if (null != riskData && riskData.isSwap) {
                    const colDef = param.column?.getColDef();
                    if (colDef && colDef.tooltipValueGetter) {
                      const partialTooltipParam = { data: order, valueFormatted: ret };
                      ret = colDef.tooltipValueGetter(partialTooltipParam as any);
                    }
                  }
                }
              }
              break;
            case "counterCcy":
              ret =
                correctParam.data.baseCurrencyCd === correctParam.data.dealtCcy
                  ? correctParam.data.nonBaseCurrencyCd
                  : correctParam.data.baseCurrencyCd;
              break;

            case COLUMN_TRADE_FIXING_SOURCE_CODE:
            case "clientComment":
            case "fillComment":
              ret =
                correctParam.data[columnId] != null
                  ? correctParam.data[columnId]
                  : EMPTY_TEXT_VALUE;
              break;

            case "salesMargin":
            case "forwardMarketPoints":
            case "forwardPoints":
              ret = param.value ? param.value.toFormat() : EMPTY_AMT_RATE_VALUE;
              break;

            case COLUMN_DEALTPERC_AWAY:
              // The percAway value from the column is adjusted when value is struckthrough,
              // the actual value is stored in order.perc
              ret = CSVExportHelper.cellFormatter(param);

              break;
            case "allocationId": {
              let allocationRef = BfxConfigIDRefHelper.getAllocationRef(param.node.data);
              ret = allocationRef != null ? allocationRef : param.value;
              break;
            }
            case "orderId": {
              let orderRef = BfxConfigIDRefHelper.getOrderRef(param.node.data);
              ret = orderRef != null ? orderRef : param.value;
              break;
            }
            // dealId
            case "id": {
              let dealRef = BfxConfigIDRefHelper.getDealRef(param.node.data);
              ret = dealRef != null ? dealRef : param.value;
              break;
            }
            case FIELD_STRATEGY_ID: {
              let strategyRef = BfxConfigIDRefHelper.getStrategyRef(param.node.data);
              ret = strategyRef != null ? strategyRef : param.value;
              break;
            }
            case "selection": {
              let activationDt = BfxConfigIDRefHelper.getActivationDt(param.node.data);
              if (activationDt != null) {
                ret = activationDt.toString();
              } else if (param.node.data?.entryDts) {
                ret = param.node.data.entryDts.toString();
              }
              break;
            }
            case COLUMN_ORDER_EXPIRY_DATE: {
              let expirationDts = param.node.data?.expiryDts;

              if (expirationDts != null) {
                ret = expirationDts.toString();
              } else {
                ret = "GTC";
              }

              break;
            }
            case "autoForwardPricingFg": {
              ret = CSVExportHelper.formatExportValue(correctParam, param.value);
              if (ret === "-") {
                ret = "";
              }
              break;
            }
            case COLUMN_MARKET_PTS:
            case COLUMN_MARKET_ALLIN:
            case "clientPts":
            case "clientAllIn":
            case "marketSwapPts":
            case "clientSwapPts":
              ret = CSVExportHelper.formatExportValue(correctParam, param.value, EMPTY_AMT_RATE_VALUE);
              break;

            default:
              ret = param.value;
              break;
          }

          // Clean strikethrough and inverted values
          try {
            if (ret != null && typeof ret == "string") {
              ret = PricingService.clearStrikeThroughString(ret);
              ret = ret.replace("&nbsp;<sup>1</sup>/<sub>n</sub>", "¹⁄ₙ");
            }
          } catch (e) {
            logger.out.warn(
              this.constructor.name +
                ": Failed to clean export value for column " +
                columnId +
                " " +
                e,
            );
          }

          return ret;
        },
      };
      return new Promise((resolve, reject) => {
        const origGetType = _event.ladderBlotter.gridOptions.api["clientSideRowModel"].getType;

        if (_exportToFile) {
          _event.ladderBlotter.gridOptions.api.exportDataAsCsv(params);
          _event.ladderBlotter.gridOptions.api["clientSideRowModel"].getType = origGetType;
          resolve(null);
        } else {
          let dataAsCsv = _event.ladderBlotter.gridOptions.api.getDataAsCsv(params);
          _event.ladderBlotter.gridOptions.api["clientSideRowModel"].getType = origGetType;
          resolve(dataAsCsv);
        }
      });
    }
  }

  protected formatDate(param: ProcessCellForExportParams, dateFormat: string) {
    return param.value != null ? param.value.format(dateFormat) : EMPTY_TEXT_VALUE;
  }
}
